<div class="ideal-footer">
    <div class="canvas-small">
        <a [href]="'ideal.footer-href' | apContent">
            {{ 'ideal.footer-text' | apContent }}
        </a>
        <ap-illustration name="volksbank"></ap-illustration>
    </div>
</div>
